export function computePartialCosts(rawMaterials) {
  return rawMaterials.map((item) => {
    const copy = { ...item };

    const usedQty = parseFloat(copy.quantity);
    const stockQty = parseFloat(copy.stock_quantity || 1);
    const stockCost = parseFloat(copy.cost);

    if (
      !isNaN(usedQty) &&
      !isNaN(stockQty) &&
      stockQty > 0 &&
      !isNaN(stockCost)
    ) {
      const partialCost = (usedQty / stockQty) * stockCost;
      copy.partial_cost = partialCost.toFixed(2);
    } else {
      copy.partial_cost = "0.00";
    }

    return copy;
  });
}

export function computePartialCostsForOtherComponents(components) {
  return components.map((comp) => {
    const componentCopy = { ...comp };
    const costPerUnit = comp.rawCost / comp.component_quantity;
    const cost = costPerUnit * comp.quantity;
    componentCopy.partial_cost = cost.toFixed(2);

    return componentCopy;
  });
}

export function computePartialCostsComponent(rawMaterials) {
  return rawMaterials.map((item) => {
    const copy = { ...item };

    const usedQty = parseFloat(copy.quantity);
    const stockQty = parseFloat(copy.stock_quantity);
    const stockCost = parseFloat(copy.cost);

    if (
      !isNaN(usedQty) &&
      !isNaN(stockQty) &&
      stockQty > 0 &&
      !isNaN(stockCost)
    ) {
      const partialCost = usedQty * stockCost;
      copy.partial_cost = partialCost.toFixed(2);
    } else {
      copy.partial_cost = "0.00";
    }

    return copy;
  });
}

export function computeTotalCost(
  productRawMat = [],
  othersComponentsRawMaterials = [],
  otherRawMaterials = [],
) {
  const sumArray = (arr) =>
    arr.reduce((sum, item) => {
      return sum + parseFloat(item?.partial_cost || 0);
    }, 0);

  const total =
    sumArray(productRawMat) +
    sumArray(otherRawMaterials) +
    sumArray(othersComponentsRawMaterials);

  return total.toFixed(2);
}

export function formatCost(value) {
  return parseFloat(value || 0).toFixed(2);
}

export function computeOtherComponentsCost(otherComponents, requiredQuantity) {
  if (!otherComponents || otherComponents.length === 0) {
    return 0;
  }

  return otherComponents.reduce((total, component) => {
    const componentQuantity = parseFloat(component.component_quantity) || 0;
    const componentCost = parseFloat(component.cost) || 0;
    const quantity = parseFloat(component.quantity) || 0;

    if (componentQuantity === 0) {
      return total;
    }

    const costPerUnit = componentCost / componentQuantity;
    const partialCost = costPerUnit * quantity;
    const finalTotal = total + partialCost;
    return finalTotal;
  }, 0);
}

export function _sumPartialCosts(arr = []) {
  return arr.reduce((sum, item) => {
    const cost = parseFloat(item?.partial_cost);
    return sum + (isNaN(cost) ? 0 : cost);
  }, 0);
}

export function calculateScale(item, userQty = null) {
  const baseQty = toNum(item.component_quantity) || 1;
  const actualQty = userQty ?? toNum(item.quantity);
  return actualQty / baseQty;
}

export function deriveUnitCost(rm) {
  const q = toNum(rm.quantity);
  const pc = toNum(rm.partial_cost);
  if (pc && q) return pc / q;

  const cost = toNum(rm.cost);
  const stock = toNum(rm.stock_quantity);
  return cost && stock ? cost / stock : 0;
}

export function toNum(v) {
  return v === undefined || v === null || v === "" ? 0 : parseFloat(String(v));
}

export function addNum(a, b, digits = 6) {
  return Number((toNum(a) + toNum(b)).toFixed(digits));
}
